import { useEffect, useState } from 'react';

/**
 * Inline-Monospace-Chip mit Copy-Button. Für Customer-Nummern, Key-Prefixes,
 * Brand-Origins etc. in DataTables.
 */
export function CopyChip({ value, label }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return undefined;
    const t = window.setTimeout(() => setCopied(false), 1200);
    return () => window.clearTimeout(t);
  }, [copied]);

  if (!value) return <span className="text-muted">—</span>;

  const onCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      /* fallback: user selects manually */
    }
  };

  return (
    <button
      type="button"
      onClick={onCopy}
      title={copied ? 'Kopiert!' : `${label ?? 'Wert'} kopieren`}
      className="btn btn-link p-0 text-decoration-none"
      style={{
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 12,
        color: copied ? 'var(--bs-success)' : 'inherit',
      }}
    >
      {value}
      <span className="ms-1 opacity-50" aria-hidden>
        {copied ? '✓' : '📋'}
      </span>
    </button>
  );
}
